module.exports = __webpack_public_path__ + "img/yw_fcpz.561dbe23.svg";